<script setup>
import { defineProps, defineEmits, computed, onMounted } from 'vue'
import { useProfileStore } from '@/stores/profile.store'
import CurrentLanguageFlag from '@/components/CurrentLanguageFlag.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const emit = defineEmits(['changeLanguage'])
const profileStore = useProfileStore()

onMounted(async () => {
  // Fetch the profile when the component is mounted
  await profileStore.fetchProfile(true)
})

// Define the new prop
const props = defineProps({
  disableChangeLanguage: {
    type: Boolean,
    default: false
  }
})

function changeLanguage(language) {
  emit('changeLanguage', language)
}

function goToAchievements() {
  router.push({ name: 'Achievements' })
}

const xp = computed(() => {
  if (profileStore && profileStore.profile) {
    return profileStore.profile.xp
  }
  // Fallback value if profileStore or profile is not available
  return 0
})

const streak = computed(() => {
  if (profileStore && profileStore.profile) {
    return profileStore.profile.streak
  }
  // Fallback value if profileStore or profile is not available
  return 0
})

</script>
<template>
  <div class="row mb-5 mb-md-3 justify-content-center shadow p-3">
    <div class="col-4 mb-md-0 text-start">
      <h6 class="fs-5 text-body-secondary txt-16-mob mb-0">
        <!-- Pass the disableChangeLanguage prop to CurrentLanguageFlag -->
        <current-language-flag 
          @changeLanguage="changeLanguage" 
          :disable-change-language="disableChangeLanguage" 
        />
      </h6>
    </div>
    <div class="col-4 mb-md-0">
      <h6 class="fs-5 text-body-secondary txt-16-mob mb-0 pointer" @click="goToAchievements"><i class="bi bi-star-fill me-1"></i> {{ xp }}</h6>
    </div>
    <div class="col-4 mb-md-0 text-end">
      <h6 class="fs-5 text-body-secondary txt-16-mob mb-0 pointer" @click="goToAchievements"><i class="bi bi-graph-up-arrow me-1"></i> {{ streak }}</h6>
    </div>
  </div>
</template>
<style scoped>
.pointer {
  cursor: pointer;
}
.bi-star-fill{
  color: #fdce4c;
}
.bi-graph-up-arrow{
  color: #0b870b;
}
</style>
